import React from 'react';
import {Route, Routes} from "react-router-dom";
import Main from "./Main";
import NewMain from "./new/Index";
import OldMain from "./old/Index";
function Hydromodul(props) {
    return (
        <Routes>
            <Route path="/" element={
                <Main />
            }/>
            <Route path="/new/*" element={
                <NewMain />
            }/>
            <Route path="/old/*" element={
                <OldMain />
            }/>
        </Routes>
    );
}

export default Hydromodul;